import React, { useState, useEffect, useContext } from "react";
//import { renderCount } from '../../../../appHelpers/appLoggers';
//import { AdminContext } from '../_context/AdminContext';
import { SectionTitleFC } from "../_helpers/SectionTitleFC";
import styled from "styled-components";
import { _UserFC } from "./Users/_UserFC";
import { _CustomerFC } from "./Customers/_CustomerFC";
import { _NetworkFC } from "./Network/_NetworkFC";
import { UsersListFC } from "./UsersListFC";
import { LoaderFC } from "../_helpers/LoaderFC";
import { CustomerListFC } from "./CustomerListFC";
import { useHistory } from "react-router-dom";
import { InputContext } from "../_context/InputContext";
import { UserContext } from "../_context/UserContext";
import { NetworkIssueListFC } from "./Network/NetworkIssueListFC";
import { AdminNavFC } from "./AdminNavFC";
import { MachinesContext } from "../home/dashboard/_context/MachinesContext";
import { IssueTrackerFC } from "./IssueTracker/IssueTrackerFC";
import { _EdgeFleetFC } from "./EdgeFleet/_EdgeFleetFC";
import { SegmentedPicker } from "../../../ui";

export const _AdminFC = () => {
  // renderCount(`AdminFC`);
  const history = useHistory();
  const [activeKey, setActiveKey] = useState("1");
  const [client, setClient] = useState("");
  const { adminViewToggle, setAdminViewToggle } = useContext(InputContext);

  const { loadingMachines, machines, getMachines } =
    useContext(MachinesContext);

  const { user, setUser, userRoles, getUserProfile, loadingUserRoles } =
    useContext(UserContext);

  const handleOnSelect = (event) => {
    if (event === "Profile") {
      setAdminViewToggle("Users");
      history.push(`admin/user/${user.email_address}`);
    } else {
      setAdminViewToggle(event);
    }
  };

  const getNavigationOptions = () => {
    const options = [];

    if (
      userRoles.includes("admin") ||
      userRoles.includes("site-admin") ||
      userRoles.includes("superuser")
    ) {
      options.push({ eventKey: "Users", label: "Manage Users" });
    }

    if (userRoles.includes("admin") || userRoles.includes("superuser")) {
      options.push({ eventKey: "Customers", label: "Manage Customers" });
    }

    if (
      userRoles.includes("network") &&
      !userRoles.includes("superuser") &&
      !userRoles.includes("admin")
    ) {
      options.push({ eventKey: "Users", label: "Manage Account" });
      options.push({ eventKey: "Network", label: "Network" });
      options.push({ eventKey: "EdgeFleet", label: "Edge Fleet" });
      options.push({ eventKey: "Issues", label: "Issue Tracker" });
    } else if (userRoles.includes("network")) {
      options.push({ eventKey: "Network", label: "Network" });
      options.push({ eventKey: "EdgeFleet", label: "Edge Fleet" });
      options.push({ eventKey: "Issues", label: "Issue Tracker" });
    }

    return options;
  };

  const setAdminPage = () => {
    if (!adminViewToggle) {
      if (
        userRoles.includes("network") &&
        !userRoles.includes("admin") &&
        !userRoles.includes("superuser")
      ) {
        setAdminViewToggle("Network");
      } else {
        setAdminViewToggle("Users");
      }
    }
  };

  useEffect(() => {
    getUserProfile();
    getMachines();
  }, []);

  useEffect(() => {
    setAdminPage();
  }, [userRoles]);

  return loadingUserRoles || loadingMachines ? (
    <LoaderFC />
  ) : (
    <>
      {/* Admin Header
      <AdminNavFC
        appearance="subtle"
        activeKey={activeKey}
        onSelect={setActiveKey}
      />*/}

      {adminViewToggle !== "ClientProfile" && (
        <NavigationContainer>
          <SegmentedPicker
            options={getNavigationOptions()}
            activeKey={adminViewToggle}
            onSelect={handleOnSelect}
            variant="glass"
            size="medium"
          />
        </NavigationContainer>
      )}

      <AdminBody>
        {userRoles.includes("superuser") ||
        userRoles.includes("admin") ||
        userRoles.includes("network") ||
        userRoles.includes("site-admin") ? (
          <>
            {adminViewToggle === "Users" ? (
              <UsersListFC setPage={setAdminViewToggle} setUser={setUser} />
            ) : adminViewToggle === "Customers" &&
              (userRoles.includes("superuser") ||
                userRoles.includes("admin")) ? (
              <CustomerListFC
                setPage={setAdminViewToggle}
                setClient={setClient}
              />
            ) : adminViewToggle === "ClientProfile" &&
              (userRoles.includes("superuser") ||
                userRoles.includes("admin")) ? (
              <_CustomerFC
                setPage={setAdminViewToggle}
                client={client}
                userRoles={userRoles}
              />
            ) : adminViewToggle === "Network" &&
              (userRoles.includes("network") ||
                userRoles.includes("superuser")) ? (
              <_NetworkFC client={client} />
            ) : adminViewToggle === "EdgeFleet" &&
              (userRoles.includes("network") ||
                userRoles.includes("superuser")) ? (
              <_EdgeFleetFC />
            ) : adminViewToggle === "Issues" &&
              (userRoles.includes("network") ||
                userRoles.includes("superuser")) ? (
              <IssueTrackerFC />
            ) : (
              <></>
            )}
          </>
        ) : (
          history.push(`/admin/user/${user.email_address}`)
        )}
      </AdminBody>
    </>
  );
};

const AdminBody = styled.div`
  width: 95vw;
  color: ${({ theme, darkMode }) =>
    darkMode ? theme.dark_accent : theme.light_accent};
  font-family: inherit;
  font-size: 3.5vw;
  font-weight: 400;

  @media screen and (min-width: 769px) {
    font-size: 1vw;
    margin-left: 10%;
    margin-right: 10%;
  }
`;

const NavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px 16px;
  background: transparent;
  min-height: 80px;
  position: relative;
  z-index: 10;

  @media screen and (max-width: 768px) {
    padding: 16px 12px;
    min-height: 70px;
  }
`;
